import { Form, Input, Modal, notification } from 'antd';
import { filterDigits } from 'mixins/helpers';
import Button from 'mixins/ui/button/button';
import React, { useState } from 'react';
import { findTaxpayerData, generatePublicApiToken } from '../actions';
import { TaxpayerInterface } from '/react4xp/parts/admin-token-generations/admin-token-generations';

const GenerateTokenModal = (props: any) => {
    const [taxpayers, setTaxpayers] = useState<TaxpayerInterface[]>([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isFindingTaxpayer, setIsFindingTaxpayer] = useState(false);

    const [modalForm] = Form.useForm();

    const handleCheckTaxpayerCode = ({ target: { value } }) => {
        filterDigits(props.modalForm, 'iinBin');

        if (value || value.trim().length === 12) {
            modalForm.validateFields(['taxpayerCode']).then(() => {
                setIsFindingTaxpayer(true);
                setTaxpayers([]);

                modalForm.resetFields(['name']);

                findTaxpayerData(value)
                    .then((taxpayerData) => {
                        const name = taxpayerData.data?.name?.replace(/\s*\/\s*null$/, '') || '';

                        modalForm.setFieldsValue({ name });

                        // if (!Array.isArray(taxpayerData.data) || taxpayerData.data.length === 0) {
                        //     notification.error({
                        //         message: 'Ошибка',
                        //         description:
                        //             'Извините, ИИН/БИН Налогоплательщика не найден в системе, проверьте корректность вводимых данных',
                        //     });
                        // } else {
                        //     setTaxpayers(taxpayerData.data);
                        // }
                    })
                    .catch(() => {
                        notification.error({
                            message: 'Ошибка',
                            description:
                                'Извините, ИИН/БИН Налогоплательщика не найден в системе, проверьте корректность вводимых данных',
                        });
                    })
                    .finally(() => setIsFindingTaxpayer(false));
            });
        }
    };

    const createToken = () => {
        modalForm.validateFields().then(() => {
            setIsLoading(true);

            const formValues = modalForm.getFieldsValue();

            generatePublicApiToken(formValues)
                .then(() => {
                    notification.success({
                        message: 'Пользователь получил токен',
                    });
                    props.handleOk();
                    modalForm.resetFields();
                })
                .finally(() => {
                    setIsLoading(false);
                });
        });
    };

    const close = () => {
        modalForm.resetFields();
        props.handleCancel();
    };

    return (
        <Modal
            title="Сгенерировать токен"
            visible={props.isModalOpen}
            onCancel={close}
            footer={[
                <Button onClick={close}>Отменить</Button>,
                <Button
                    onClick={createToken}
                    loading={isLoading}
                >
                    Создать
                </Button>,
            ]}
        >
            <Form
                name="basic"
                layout="vertical"
                form={modalForm}
                onFinish={props.handleOk}
            >
                <Form.Item
                    label="ИИН/БИН"
                    name="taxpayerCode"
                    rules={[
                        {
                            required: true,
                            message: 'Поле обязательно для заполнения',
                        },
                        {
                            min: 12,
                            message: 'Поле ИИН должно состоять из 12 цифр',
                        },
                    ]}
                >
                    <Input
                        onChange={handleCheckTaxpayerCode}
                        maxLength={12}
                        size="large"
                        placeholder="Введите значение"
                        className="input"
                    />
                </Form.Item>
                <Form.Item
                    label="ФИО/Наименование организации"
                    name="name"
                    rules={[
                        {
                            required: true,
                            message: 'Поле обязательно для заполнения',
                        },
                    ]}
                >
                    <Input
                        size="large"
                        readOnly
                        disabled
                    />
                    {/* <Select
                        size="large"
                        placeholder="Введите значение"
                        loading={isFindingTaxpayer}
                        options={taxpayers.map((x, index) => {
                            return {
                                label: getFullName(
                                    x.name.lastname,
                                    x.name.firstname,
                                    x.name.middlename
                                ),
                                value: getFullName(
                                    x.name.lastname,
                                    x.name.firstname,
                                    x.name.middlename
                                ),
                                key: index,
                            };
                        })}
                    /> */}
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default GenerateTokenModal;
